import React, { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import Icon, { PauseCircleFilled, PlayCircleFilled } from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as RobotSvg } from './robot.svg';

type Status = 'idle' | 'paused' | 'working';

export interface RobotIconProps extends HTMLAttributes<HTMLSpanElement> {
  component?: IconComponentProps['component'];
  status?: Status;
}

const Span = styled.span<{ bgColor?: string; color?: string }>`
  position: relative;
  width: 1.1em;
  height: 1.1em;
  line-height: 1.1em;
  font-size: 1em;
  text-align: center;
  display: inline-block;
  display: flex;
  align-items: center;
  margin-left: 0.2em;
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};
  border-radius: 0.1em;
  > span {
    width: 100%;
    margin-left: 0.06em;
  }
`;
const StatusIcon = styled.b<{ color?: string }>`
  position: absolute;
  bottom: 0.3em;
  right: 0.1em;
  font-size: 0.4em;
  color: ${({ color }) => color};
  background: #fff;
  border-radius: 50%;
  line-height: 0;
`;
const statusColorMap: Record<Status, string> = {
  idle: '#ssss',
  paused: '#f2a100',
  working: '#00BF69',
};
const RobotIcon = (props: RobotIconProps) => {
  const { status = 'idle', component = RobotSvg, ...spanProps } = props;
  let statusIcon = null;
  if (status === 'paused') {
    statusIcon = <PauseCircleFilled />;
  } else if (status === 'working') {
    statusIcon = <PlayCircleFilled />;
  }
  return (
    <Span bgColor="#F1F4FF" color="#92A7FB" {...spanProps}>
      <Icon component={component} />
      <StatusIcon color={statusColorMap[status]}>{statusIcon}</StatusIcon>
    </Span>
  );
};
export default React.memo(RobotIcon);
